/**
 * Overage dropdown (snippets/product-overage.liquid).
 * Re-emits the select's change as a bubbling `overage:change` with `detail.percent`,
 * so the box calculator and sqft-overage can recalculate.
 * If `data-size-defaults` is set (e.g. Tile size 15%, Paver size 10%), picking a Size with a
 * different default selects that default.
 * See docs/dev/docs-product-overage.md
 */
if (!customElements.get('overage-select')) {
  customElements.define(
    'overage-select',
    class OverageSelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-overage-select]')
        this.onChange = this.onChange.bind(this)
        this.select?.addEventListener('change', this.onChange)

        this.currentDefault = this.dataset.default
        this.sizeOption = this.dataset.sizeOption
        this.sizeDefaults = this.parseSizeDefaults()
        if (this.sizeDefaults && this.sizeOption) {
          this.onOptionChange = this.onOptionChange.bind(this)
          document.addEventListener('change', this.onOptionChange)
        }
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.onChange)
        if (this.onOptionChange) {
          document.removeEventListener('change', this.onOptionChange)
        }
      }

      get percent() {
        const value = parseFloat(this.select?.value)
        return Number.isFinite(value) && value > 0 ? value : 0
      }

      parseSizeDefaults() {
        if (!this.dataset.sizeDefaults) return null
        try {
          return JSON.parse(this.dataset.sizeDefaults)
        } catch (e) {
          return null
        }
      }

      // Reads the Size input directly: picking a Size + Color combo that doesn't exist
      // never publishes variantChange, but the default should still follow the Size.
      onOptionChange(event) {
        const target = event.target
        if (!target || !this.select) return
        const name = target.getAttribute('name')
        if (name !== this.sizeOption && name !== `options[${this.sizeOption}]`)
          return
        if (target.getAttribute('form') !== this.select.getAttribute('form'))
          return
        const nextDefault = this.sizeDefaults[target.value]
        if (!nextDefault || nextDefault === this.currentDefault) return
        this.currentDefault = nextDefault
        const hasOption = [...this.select.options].some(
          (option) => option.value === nextDefault
        )
        if (!hasOption) return
        this.select.value = nextDefault
        this.onChange()
      }

      onChange() {
        this.dispatchEvent(
          new CustomEvent('overage:change', {
            bubbles: true,
            detail: { percent: this.percent }
          })
        )
      }
    }
  )
}
